<template>
    <div class="Offers">
        <menuBox :step="4"></menuBox>
        <div class="about-title">招賢納士</div>
        <div class="Offers-text">
            <p> AZALEA TECH  CO., LIMITED 相信團隊合作。我們提供極富創意和創新的環境，使團隊成員能夠從事設計和開發工作。我們獎勵智慧、奉獻精神和創新思維。我們是一支自我驅動的專業團隊，對新技術和創意充滿熱情。我們的跨學科團隊一直在創造結合良好實踐、高質量軟件和新技術的獨特產品。 </p>
            <p>我們正在尋找熱愛並富有創造力、熱情和創新理念的團隊合作人才加入我們的團隊，快來利用這個機會並探索您的想法，發送您的簡歷到 <span>13724166@qq.com</span></p>
        </div>
        <div class="offers-list">
            <div class="offers-box">
                <div class="name">SaaS產品經理   <span>/ 12-18k</span></div>
                <div class="offers-title">工作職責：</div>
                <div class="offers-text">  
                    1. 負責人力資源相關業務平台產品的規劃和設計，獨立負責產品需求定義、方案設計，把握產品調性，控制產品風險並協同各方資源完成產品交付；
                    <br> 2. 推進產品迭代、項目管理、敏捷規劃、產品驗收；
                    <br> 3. 跟踪上線後反饋情況，持續優化產品方案的用戶體驗；
                </div>
                <div class="offers-title">任職要求：</div>
                <div class="offers-text">  
                    1. 本科及以上學歷；
                    <br> 2. 3年及以上產品經驗，有Saas類產品經驗優先；
                    <br> 3. 熟練掌握互聯網產品設計相關軟件，如Sketch，Axure，Visio等；
                    <br> 4. 具備優秀的溝通組織協調，推進執行能力；
                    <br> 5. 善於系統思考、自我驅動，能夠站在業務視角審視、發現并快速解決問題。
                </div>
            </div>
            <div class="offers-box">
                <div class="name">網絡安全工程師  <span>/ 11-15k</span></div>
                <div class="offers-title">工作職責：</div>
                <div class="offers-text">                                            
                        1、參與公司網絡安全項目規劃和建設，協助制定安全策略和管理流程；
                        <br> 2、負責防火牆、VPN、漏洞掃描、堡壘機、安全審計等設備日常管理工作；
                        <br> 3、負責定期對各項目系統進行安全測試（黑盒、白盒）、滲透測試，發現內部信息系統的安全隱患；
                        <br> 4、負責跟踪安全漏洞、補丁信息，提出解決方案，和多部門協同進行處理；
                </div>
                <div class="offers-title">任職要求：</div>
                <div class="offers-text">  
                    1、大學本科及以上學歷，計算機、通信、信息安全工程等相關專業，兩年以上同崗位工作經驗；
                    <br> 2、掌握攻擊溯源分析方法和手段，熟悉主流的安全攻擊手段及其對應的防禦方法；
                </div>
            </div>
            <div class="offers-box">
                <div class="name">前端工程師   <span>/ 8-12k</span></div>
                <div class="offers-title">工作職責：</div>
                <div class="offers-text">    
                    1、負責可視化平台及組件框架的設計和研發；
                    <br> 2、負責產品移動端的設計和研發。
                </div>
                <div class="offers-title">任職要求：</div>
                <div class="offers-text">  
                    1、本科及以上學歷，2年或以上的Web前端開發經驗；
                    <br> 2、熟悉W3C標準網站構建，有構建高性能網站應用相關經驗，對數據流程和標準有一定理解；
                    <br> 3、精通Javascript、及主流JS框架，對Vue或者React有豐富的開發經驗，對於可視化開發有一定經驗；
                    <br> 4、有強烈的創新精神並能付諸實施，能積極學習業界新技術；
                    <br> 5、有責任心，優秀的團隊合作精神，良好的溝通表達和邏輯分析能力；
                    <br> 6、有SaaS（OA, HR, CRM, BI等）相關從業經驗者優先。
                </div>
            </div>
            <div class="offers-box">
                <div class="name">數據運營   <span>/ 11-15k</span></div>
                <div class="offers-title">工作職責：</div>
                <div class="offers-text"> 
                    1、負責日常業務數據統計與分析，客戶使用產品日常數據整理，包括定期的日報、週報、月報；
                    <br> 2、具備較強的數據處理、分析能力，邏輯思維強，能夠獨立完成數據分析報告；
                    <br> 3、與客戶通過郵件，IM進行溝通，處理客戶提出的各種問題，維繫客戶關係；
                </div>
                <div class="offers-title">任職要求：</div>
                <div class="offers-text">  
                    1、大專及以上學歷，有互聯網項目經驗優先；
                    <br> 2、有一定數據統計、分析經驗;
                    <br> 3、邏輯清晰，對數據的合理性、準確性有自身判斷能力。
                </div>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.about-title {
    background-image: url(../assets/about-1.png);
    width: 100%;
    height: 320px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    font-weight: 500;
    color: #333333;
}

.Offers-text {
    padding: 80px 360px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;

    p {
        text-indent: 2em;
        margin-top: 28px;
        span{
            color: #B043FC;
        }
    }
}

.offers-list{
    padding: 0px 340px 96px 340px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .offers-box{
        width: 520px;
        height: 509px;
        background: #FFFFFF;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.08);
        border-radius: 8px;
        border: 1px solid #EBEBEB;
        padding: 40px 30px;
        margin-top: 40px;
        .name{
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            span{
                font-size: 24px;
                color: #999999;
            }
        }
        .offers-title{
            margin-top: 28px;
            font-size: 20px;
            font-weight: 600;
            color: #333333;
        }
        .offers-text{
            font-size: 20px;
            color: #999999;
        }
    }
}

</style>